import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
interface XtdhContributorSummaryProps {
  readonly activeCount: string;
  readonly totalCount: string;
  readonly className?: string | undefined;
}
export function XtdhContributorSummary(t0) {
  const $ = _c(12);
  const {
    activeCount,
    totalCount,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx("tw-grid sm:tw-grid-cols-3 md:tw-grid-cols-2 tw-gap-4 tw-text-left lg:tw-self-center tw-mb-0 tw-mt-2 lg:tw-mt-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <dt className="tw-m-0 tw-text-[10px] tw-font-medium tw-uppercase tw-truncate tw-tracking-wider tw-text-iron-500 tw-mb-1.5">Active contributors</dt>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== activeCount) {
    t3 = <div className="tw-flex tw-flex-col">{t2}<dd className="tw-m-0 tw-text-base tw-font-semibold tw-leading-tight tw-text-iron-50">{activeCount}</dd></div>;
    $[3] = activeCount;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <dt className="tw-m-0 tw-text-[10px] tw-font-medium tw-uppercase tw-tracking-wider tw-text-iron-500 tw-mb-1.5">Contributors</dt>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== totalCount) {
    t5 = <div className="tw-flex tw-flex-col">{t4}<dd className="tw-m-0 tw-text-base tw-font-semibold tw-leading-tight tw-text-iron-50">{totalCount}</dd></div>;
    $[6] = totalCount;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t5) {
    t6 = <dl className={t1}>{t3}{t5}</dl>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}